import styled from "styled-components"

import CloudinaryImage from "components/cloudinary-image"

export const Container = styled.div`
  margin-bottom: 2rem;
  display: flex;
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  color: #767676;
`

export const DisclaimerLink = styled.a`
  text-decoration: underline;
`

export const For = styled.span`
  padding-right: 10px;
`

export const Image = styled(CloudinaryImage)`
  height: 2.2rem;
  max-width: 12rem;

  img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
